/* Linen: product page main section. Gallery slider, size picking, add to cart / buy now
   through Linen.cart (assets/linen-cart.js), size sheet and sticky bar. */
if (!customElements.get('linen-product-main')) {
  customElements.define(
    'linen-product-main',
    class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-pm-form]');
        this.idInput = this.form && this.form.querySelector('input[name="id"]');
        this.sheet = this.querySelector('[data-pm-sheet]');
        this.sticky = this.querySelector('[data-pm-sticky]');
        this.error = this.querySelector('[data-pm-error]');
        this.sheetError = this.querySelector('[data-pm-sheet-error]');
        this.mode = 'add';
        var pre = this.querySelector('[data-pm-size][aria-pressed="true"]');
        this.variant = pre ? pre.dataset.variantId : null;

        this.onClick = this.onClick.bind(this);
        this.onKey = this.onKey.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKey);
        if (this.form) this.form.addEventListener('submit', this.onSubmit);

        this.initGallery();
        this.initSticky();
        this.initOffers();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKey);
        if (this.form) this.form.removeEventListener('submit', this.onSubmit);
        if (this.io) this.io.disconnect();
        if (this.onCart) document.removeEventListener('linen:cart:updated', this.onCart);
        if (this.sheet && window.Linen && Linen.closeModal) Linen.closeModal(this.sheet);
      }

      /* Gallery */
      initGallery() {
        var track = (this.track = this.querySelector('[data-pm-track]'));
        if (!track) return;
        this.slides = Array.prototype.slice.call(track.children);
        this.segs = this.querySelectorAll('.linen-pm__seg');
        this.count = this.querySelector('[data-pm-count]');
        this.prev = this.querySelector('[data-pm-prev]');
        this.next = this.querySelector('[data-pm-next]');
        this.index = 0;
        var ticking = false;
        var self = this;
        track.addEventListener(
          'scroll',
          function () {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(function () {
              ticking = false;
              self.syncGallery();
            });
          },
          { passive: true }
        );
      }

      syncGallery() {
        var track = this.track;
        var n = this.slides.length;
        var w = this.slides[0].offsetWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) i = n - 1;
        i = Math.max(0, Math.min(n - 1, i));
        if (i === this.index) return;
        this.index = i;
        this.segs.forEach(function (seg, k) {
          seg.classList.toggle('is-active', k === i);
        });
        if (this.count) this.count.textContent = i + 1 + ' / ' + n;
        if (this.prev) this.prev.hidden = i === 0;
        if (this.next) this.next.hidden = i === n - 1;
      }

      goTo(i) {
        var n = this.slides.length;
        i = Math.max(0, Math.min(n - 1, i));
        this.track.scrollTo({ left: this.slides[i].offsetLeft - this.slides[0].offsetLeft, behavior: 'smooth' });
      }

      /* Sticky bar: visible while the main buttons are off screen */
      initSticky() {
        var cta = this.querySelector('[data-pm-form]') || this.querySelector('[data-pm-cta]');
        var sticky = this.sticky;
        if (!sticky || !cta || !('IntersectionObserver' in window)) return;
        this.io = new IntersectionObserver(
          function (entries) {
            var show = !entries[0].isIntersecting;
            sticky.classList.toggle('is-visible', show);
            sticky.inert = !show;
          },
          { rootMargin: '0px 0px -60px 0px' }
        );
        this.io.observe(cta);
      }

      /* Offers: sticky offer line, "add a 2nd item" nudge and the add-to-cart popup */
      initOffers() {
        this.pop = this.querySelector('[data-pm-pop]');
        this.nudge = this.querySelector('[data-pm-nudge]');
        this.nudgeDone = this.querySelector('[data-pm-nudge-done]');
        this.stickyOffer = this.querySelector('[data-pm-sticky-offer]');
        var node = this.querySelector('[data-pm-data]');
        try {
          this.data = JSON.parse(node.textContent);
          this.data.colours = (this.data.colours || []).filter(Boolean);
        } catch (e) {
          this.data = null;
        }
        if (!this.data) return;
        this.onCart = this.refreshOffers.bind(this);
        document.addEventListener('linen:cart:updated', this.onCart);
        this.refreshOffers();
      }

      fmt(cents) {
        return Linen.formatMoney(Math.round(cents));
      }

      fill(text, map) {
        text = text || '';
        Object.keys(map).forEach(function (k) {
          text = text.split('[' + k + ']').join(map[k]);
        });
        return text;
      }

      offerCount() {
        var c = document.querySelector('[data-linen-bag-content]');
        return c ? parseInt(c.getAttribute('data-offer-count'), 10) || 0 : 0;
      }

      money() {
        var P = this.data.price;
        var pct = this.data.pct;
        var save = Math.round((2 * P * pct) / 100);
        return { save: save, more: Math.round((2 * P * (100 - pct)) / 100) - P };
      }

      currentSize() {
        var on = this.querySelector('[data-pm-size][aria-pressed="true"]');
        return on ? on.dataset.size : '';
      }

      colourTiles(size, attr, skip, kind) {
        var list = this.data.colours.filter(function (c) {
          return c.v && c.v[size] && !(skip && skip.indexOf(c.handle) > -1);
        });
        if (kind === 'nudge') list = list.slice(0, 4);
        var plus = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>';
        return {
          list: list,
          html: list
            .map(function (c, i) {
              var name = String(c.name).replace(/</g, '');
              var img = c.img ? '<img src="' + c.img + '" alt="" loading="lazy">' : '';
              if (kind === 'nudge') {
                return '<button type="button" class="linen-pm__ntile" ' + attr + '="' + i + '" aria-label="' + name.replace(/"/g, '') + '"><span class="linen-pm__ntile-img">' + img + '<span class="linen-pm__ntile-plus">' + plus + '</span></span><span class="linen-pm__ntile-name">' + name + '</span></button>';
              }
              return '<button type="button" class="linen-pm-pop__tile" ' + attr + '="' + i + '" aria-label="' + name.replace(/"/g, '') + '" aria-pressed="false">' + img + '<span>' + name + '</span></button>';
            })
            .join('')
        };
      }

      async refreshOffers() {
        var n = this.offerCount();
        var d = this.data;
        var sticky = this.stickyOffer;
        if (sticky) {
          var key = n >= 2 ? 'offer2' : n === 1 ? 'offer1' : 'offer0';
          sticky.textContent = this.fill(sticky.dataset[key], { pct: d.pct });
        }
        if (!this.nudge) return;
        if (n < 1) {
          this.nudge.hidden = true;
          if (this.nudgeDone) this.nudgeDone.hidden = true;
          return;
        }
        var cart;
        try {
          cart = await (await fetch('/cart.js')).json();
        } catch (e) {
          return;
        }
        if (n >= 2) {
          this.nudge.hidden = true;
          if (this.nudgeDone) {
            this.nudgeDone.hidden = false;
            this.nudgeDone.textContent = this.fill(this.nudgeDone.dataset.tpl, { pct: d.pct, total: this.fmt(cart.total_price) });
          }
          return;
        }
        if (this.nudgeDone) this.nudgeDone.hidden = true;
        var handles = cart.items.map(function (i) {
          return i.handle;
        });
        var size = this.currentSize();
        cart.items.forEach(function (i) {
          (i.options_with_values || []).forEach(function (o) {
            if (o.name === d.sizeOption) size = o.value;
          });
        });
        var t = this.colourTiles(size, 'data-pm-nudge-tile', handles, 'nudge');
        if (!t.list.length) {
          this.nudge.hidden = true;
          return;
        }
        this.nudgeList = t.list;
        this.nudgeSize = size;
        var m = this.money();
        this.querySelector('[data-pm-nudge-title]').textContent = this.fill(this.nudge.dataset.title, { save: this.fmt(m.save), pct: d.pct });
        this.querySelector('[data-pm-nudge-text]').textContent = this.fill(this.nudge.dataset.text, { size: size, pct: d.pct });
        this.querySelector('[data-pm-nudge-tiles]').innerHTML = t.html;
        this.nudge.hidden = false;
      }

      async addColour(colour, size) {
        if (!colour || !colour.v[size]) return;
        try {
          await Linen.cart.add([{ id: colour.v[size], quantity: 1 }]);
        } catch (err) {
          this.setError(this.error, err && err.message);
        }
      }

      openPop() {
        var d = this.data;
        var size = this.currentSize();
        if (!d || !this.pop || !size) return Linen.cart.openBag();
        var pop = this.pop;
        var t = this.colourTiles(size, 'data-pm-pop-tile', [], 'pop');
        this.popList = t.list;
        this.popSize = size;
        this.popIndex = 0;
        var m = this.money();
        var title = this.querySelector('.linen-pm__title');
        var colour = this.querySelector('.linen-pm__sub');
        var added = (colour ? colour.textContent.split('·')[0].trim() + ' shirt' : title ? title.textContent.trim() : '') + ' · ' + this.dataset.sizeWord + ' ' + size;
        pop.querySelector('[data-pm-pop-added]').textContent = added;
        var hasUp = t.list.length > 0;
        pop.querySelector('[data-pm-pop-upsell]').hidden = !hasUp;
        if (hasUp) {
          pop.querySelector('[data-pm-pop-title]').textContent = this.fill(pop.dataset.title, { save: this.fmt(m.save), pct: d.pct });
          pop.querySelector('[data-pm-pop-sub]').textContent = this.fill(pop.dataset.sub, { more: this.fmt(m.more), pct: d.pct });
          pop.querySelector('[data-pm-pop-tiles]').innerHTML = t.html;
          this.pickPop(0);
        }
        var pantsBox = pop.querySelector('[data-pm-pop-pants]');
        if (d.pair) {
          var P = d.price;
          var more = d.pair.price - Math.round(((P + d.pair.price) * d.pct) / 100);
          pantsBox.querySelector('[data-pm-pop-pants-img]').src = d.pair.img || '';
          pantsBox.querySelector('[data-pm-pop-pants-name]').textContent = d.pair.name;
          var price = this.fmt(d.pair.price) + (d.pair.compare > d.pair.price ? ' <s>' + this.fmt(d.pair.compare) + '</s>' : '');
          pantsBox.querySelector('[data-pm-pop-pants-price]').innerHTML = price;
          pantsBox.querySelector('[data-pm-pop-pants-text]').textContent = this.fill(pop.dataset.pants, { pct: d.pct, more: this.fmt(more) });
          pantsBox.querySelector('[data-pm-pop-pants-add]').textContent = this.fill(pop.dataset.pantsAdd, { size: d.pair.size || '' });
          pantsBox.hidden = false;
        } else {
          pantsBox.hidden = true;
        }
        if (!hasUp && !d.pair) return Linen.cart.openBag();
        Linen.openModal(pop);
      }

      pickPop(i) {
        var c = this.popList[i];
        if (!c) return;
        this.popIndex = i;
        this.pop.querySelectorAll('[data-pm-pop-tile]').forEach(function (b, k) {
          b.setAttribute('aria-pressed', String(k === i));
        });
        this.pop.querySelector('[data-pm-pop-yes]').textContent = this.fill(this.pop.dataset.yes, { colour: c.name, more: this.fmt(this.money().more) });
      }

      async afterAdd() {
        if (this.pop && this.data && this.offerCount() === 1) this.openPop();
        else Linen.cart.openBag();
      }

      /* Sizes */
      select(size) {
        var buttons = this.querySelectorAll('[data-pm-size], [data-pm-sheet-size]');
        var picked = null;
        buttons.forEach(function (b) {
          var on = b.dataset.size === size;
          b.setAttribute('aria-pressed', String(on));
          if (on) picked = b;
        });
        if (!picked) return;
        var d = picked.dataset;
        this.variant = d.variantId;
        if (this.idInput) this.idInput.value = d.variantId;

        var label = this.querySelector('[data-pm-size-label]');
        if (label) label.textContent = size;
        var stickySize = this.querySelector('[data-pm-sticky-size]');
        if (stickySize) stickySize.textContent = this.dataset.sizeWord + ' ' + size;
        var stickyBtn = this.querySelector('[data-pm-sticky-add]');
        if (stickyBtn) stickyBtn.textContent = this.dataset.addLabel;

        var price = Number(d.price);
        var compare = Number(d.compare);
        var hasCompare = compare > price;
        this.querySelectorAll('[data-pm-price]').forEach(function (el) {
          el.textContent = Linen.formatMoney(price);
        });
        this.querySelectorAll('[data-pm-compare]').forEach(function (el) {
          el.hidden = !hasCompare;
          if (hasCompare) el.textContent = Linen.formatMoney(compare);
        });
        var off = this.querySelector('[data-pm-off]');
        if (off) {
          off.hidden = !hasCompare;
          if (hasCompare) off.textContent = off.textContent.replace(/^\d+/, String(Math.floor(((compare - price) * 100) / compare)));
        }

        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', d.variantId);
          history.replaceState(history.state, '', url.toString());
        } catch (e) {}
      }

      setError(el, message) {
        if (!el) return;
        el.textContent = message || '';
        el.hidden = !message;
      }

      openSheet(mode, opener) {
        this.mode = mode;
        this.setError(this.sheetError, '');
        if (this.sheet) Linen.openModal(this.sheet, opener);
      }

      async add(button) {
        if (!this.variant) return this.openSheet('add', button);
        if (!window.Linen || !Linen.cart) return this.form.submit();
        this.setError(this.error, '');
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        try {
          await Linen.cart.add([{ id: Number(this.variant), quantity: 1 }], { openBag: false });
          this.afterAdd();
        } catch (err) {
          this.setError(this.error, err && err.message);
        } finally {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
        }
      }

      buyNow(event, opener) {
        if (!this.variant) return this.openSheet('buy', opener);
        if (!window.Linen || !Linen.cart) return this.form.submit();
        var el = this.querySelector('[data-pm-buy]');
        if (el && el.classList.contains('is-loading')) return;
        if (el) {
          el.classList.add('is-loading');
          el.setAttribute('aria-disabled', 'true');
        }
        Promise.resolve(Linen.cart.buyNow(Number(this.variant), 1, event)).finally(function () {
          setTimeout(function () {
            if (!el) return;
            el.classList.remove('is-loading');
            el.removeAttribute('aria-disabled');
          }, 3000);
        });
      }

      async pickFromSheet(button, event) {
        this.select(button.dataset.size);
        if (this.mode === 'buy') {
          Linen.closeModal(this.sheet);
          this.buyNow(event);
          return;
        }
        if (!window.Linen || !Linen.cart) return this.form.submit();
        this.setError(this.sheetError, '');
        button.classList.add('is-loading');
        Linen.closeModal(this.sheet);
        try {
          await Linen.cart.add([{ id: Number(this.variant), quantity: 1 }], { openBag: false });
          this.afterAdd();
        } catch (err) {
          this.setError(this.sheetError, err && err.message);
          Linen.openModal(this.sheet);
        } finally {
          button.classList.remove('is-loading');
        }
      }

      onSubmit(event) {
        event.preventDefault();
        this.add(this.querySelector('[data-pm-atc]'));
      }

      onClick(event) {
        var t = event.target;
        var el;
        if ((el = t.closest('[data-pm-sheet-size]'))) {
          if (el.getAttribute('aria-disabled') !== 'true') this.pickFromSheet(el, event);
        } else if ((el = t.closest('[data-pm-size]'))) {
          if (el.getAttribute('aria-disabled') !== 'true') this.select(el.dataset.size);
        } else if ((el = t.closest('[data-pm-buy]'))) {
          this.buyNow(event, el);
        } else if ((el = t.closest('[data-pm-sticky-add]'))) {
          this.add(el);
        } else if ((el = t.closest('[data-pm-sticky-buy]'))) {
          this.buyNow(event, el);
        } else if ((el = t.closest('[data-pm-nudge-tile]'))) {
          this.addColour(this.nudgeList[Number(el.getAttribute('data-pm-nudge-tile'))], this.nudgeSize);
        } else if ((el = t.closest('[data-pm-pop-tile]'))) {
          this.pickPop(Number(el.getAttribute('data-pm-pop-tile')));
        } else if (t.closest('[data-pm-pop-yes]')) {
          Linen.closeModal(this.pop);
          this.addColour(this.popList[this.popIndex], this.popSize);
        } else if (t.closest('[data-pm-pop-pants-add]')) {
          Linen.closeModal(this.pop);
          Linen.cart.add([{ id: this.data.pair.id, quantity: 1 }]).catch(function () {});
        } else if (t.closest('[data-pm-pop-no]')) {
          Linen.closeModal(this.pop);
          Linen.cart.openBag();
        } else if (t.closest('[data-pm-nudge-done]')) {
          Linen.cart.openBag();
        } else if (t.closest('[data-pm-prev]')) {
          this.goTo(this.index - 1);
        } else if (t.closest('[data-pm-next]')) {
          this.goTo(this.index + 1);
        } else if ((el = t.closest('[data-pm-guide]'))) {
          var item = window.Linen && Linen.openAccordion ? Linen.openAccordion(el.dataset.pmGuide) : null;
          if (item) {
            event.preventDefault();
            item.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      }

      onKey(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        var el = event.target.closest('[data-pm-buy]');
        if (!el) return;
        event.preventDefault();
        this.buyNow(event, el);
      }
    }
  );
}
